import React from 'react';
import { getAppointmentOrderTypeLabel } from '../utils/appointmentOrderOptions';

const ReportExaminationOrders = ({ orders, title, description, emptyMessage, t }) => {
  const examinationOrders = Array.isArray(orders) ? orders : [];

  return (
    <section className="report-examination-orders" aria-labelledby="report-examination-orders-title">
      <div className="report-examination-orders__heading">
        <h4 id="report-examination-orders-title" className="report-subsection-title">
          {title}
        </h4>
        <p>{description}</p>
      </div>
      {examinationOrders.length > 0 ? (
        <div className="report-examination-orders__list">
          {examinationOrders.map((order) => (
            <div className="report-examination-orders__item" key={order.id}>
              <div className="report-examination-orders__type">
                {getAppointmentOrderTypeLabel(order.check_type, t)}
              </div>
              {order.description && (
                <div className="report-examination-orders__description">
                  {order.description}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="report-examination-orders__empty">{emptyMessage}</p>
      )}
    </section>
  );
};

export default ReportExaminationOrders;
